var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#34318A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10538 7.46109L8.136 8.54109L9.216 8.00109L6.63469 6.60271V4.14009L11.5976 6.71634L12.6776 6.17634L6.32138 2.84409C6.2489 2.80601 6.16781 2.7873 6.08597 2.78977C6.00413 2.79224 5.92432 2.81581 5.85427 2.85819C5.78422 2.90057 5.7263 2.96033 5.68614 3.03167C5.64597 3.10301 5.62491 3.18352 5.625 3.2654V6.67809C5.62669 7.00827 5.81175 7.31034 6.10538 7.46109ZM13.8437 6.88846C13.7735 6.82027 13.684 6.77541 13.5873 6.76C13.4907 6.7446 13.3916 6.75941 13.3037 6.8024L6.10538 10.5391C5.81006 10.691 5.62444 10.9953 5.625 11.3277V14.7348C5.62491 14.8166 5.64597 14.8972 5.68614 14.9685C5.7263 15.0398 5.78422 15.0996 5.85427 15.142C5.92432 15.1844 6.00413 15.2079 6.08597 15.2104C6.16781 15.2129 6.2489 15.1942 6.32138 15.1561L13.5034 11.4301C13.8032 11.2748 13.9894 10.9632 13.9843 10.6257V7.22371C13.9843 7.16129 13.9719 7.09949 13.9478 7.04193C13.9236 6.98437 13.8882 6.93219 13.8437 6.88846ZM12.9797 10.5661L6.63469 13.8601V11.3975L12.9797 8.10346V10.5661Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudr);
export default __webpack_public_path__ + "static/media/audr.96e018268b413b4bf02521af1a4f0e73.svg";
export { ForwardRef as ReactComponent };